import styled from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const RemoveButton = styled.span<IWithSize>`
  background-color: #f70011;
  border: 0px;
  border-radius: 3px;
  color: #ffffff;
  cursor: pointer;
  font-size: ${({ size }) => (size ? 16 * size : 16)}px;
  font-weight: 600;
  padding: ${({ size }) => (size ? 10 * size : 10)}px
    ${({ size }) => (size ? 30 * size : 30)}px;
`

export default RemoveButton
